import React from 'react'
// import Routes from 'src/Routes/Routes'
import Routes from './Routes/Routes'
import './App.css';
import { MuiThemeProvider } from '@material-ui/core'
import { themes } from 'themes';
import {Provider} from 'react-redux'
import configureStore from 'store/store';
import Axios from 'axios';

const store = configureStore()
Axios.defaults.baseURL = 'https://strapi.useinfluence.co'


function App() {
  return (
    <MuiThemeProvider theme={themes}>
      <Provider store={store}>
        <div>
          <Routes />
        </div>
        </Provider>
    </MuiThemeProvider>
  )
}

export default App;
